import { render, staticRenderFns } from "./PasswordResetScreen.vue?vue&type=template&id=f70c805a&scoped=true&lang=pug"
import script from "./PasswordResetScreen.vue?vue&type=script&lang=ts"
export * from "./PasswordResetScreen.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetScreen.vue?vue&type=style&index=0&id=f70c805a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c805a",
  null
  
)

export default component.exports